import * as React from 'react'

import { spacing, Text } from 'main/ui'
import { palette } from '../constants'
import RangeSlider, { IRangeProps } from './RangeSlider'

interface IProps {
  minValue: number
  maxValue: number
  step?: number
  value: IRangeProps
  participatesInAssessment: boolean
  onChange: (value: IRangeProps) => void
  label: string
}

export default function NetworkAssessmentSlider(props: IProps) {
  const { minValue, maxValue, step = 50, value, participatesInAssessment, onChange, label } = props

  return (
    <div>
      <div style={{ marginTop: `${spacing.majorScale(2)}px` }}>
        <RangeLabel
          value={value}
          participatesInAssessment={participatesInAssessment}
          label={label}
        />
      </div>
      <div
        style={{
          marginTop: `${spacing.majorScale(2)}px`,
          marginBottom: `${spacing.majorScale(2)}px`,
          marginLeft: `${spacing.minorScale(1)}px`,
          marginRight: `${spacing.minorScale(-4)}px`,
        }}
      >
        <RangeSlider
          range={{ min: minValue, max: maxValue }}
          step={step}
          value={value}
          onChange={onChange}
        />
        <RangeLabelBottom value={value} />
      </div>
    </div>
  )
}

const RangeLabel = (props: {
  value: IRangeProps
  participatesInAssessment: boolean
  label: string
}) => {
  const { participatesInAssessment: participatesInAssessment, label: label } = props

  if (participatesInAssessment) {
    return (
      <div>
        <AssessmentScoreTextLabel label={label} fontSize={14} muted />
      </div>
    )
  }

  return <div />
}

const AssessmentScoreTextLabel = (props: { fontSize?: number; muted?: boolean; label: string }) => {
  const { fontSize: fontSize, muted: muted, label: label } = props
  return (
    <div>
      <Text fontSize={fontSize} muted={muted}>
        {label}
      </Text>
    </div>
  )
}

const RangeLabelBottom = (props: { value: IRangeProps }) => {
  const {
    value: { min, max },
  } = props

  return (
    <div
      style={{
        color: palette.mediumGray,
        display: 'flex',
        fontSize: '11px',
        justifyContent: 'space-between',
        paddingTop: '2.5px',
      }}
    >
      <span style={{ marginLeft: '-4px' }}>{(min / 100).toFixed(2)}</span>
      <span style={{ marginRight: '18px' }}>{(max / 100).toFixed(2)}</span>
    </div>
  )
}
